
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Partners from "../components/Partners";
import Services from "../pages/what";
import Why from "../pages/Why"; 
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import "./Home.css";

function Home() {
  return (
    <div className="homepage-bg">
      
      <main>
        <Hero />
        <Partners />
        <Services />
        <Why />
      </main>
    </div>
  );
}

export default Home;
